import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { FormattedMessage,  useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useTheme } from "styled-components";

import routing from "../../../routing";
import Loader, { LoaderWrapper } from "../../../components/Loader";
import PlanCard from "../../../components/PlanCard";
import { Select, Title } from "../../../components/Form";
import { get } from "../../../actions/general";
import Method from "../../../components/Method";

import { parseClasses } from "../../plan/NewHomeworkModal/utils";
import { IClass } from "../../homeworks/interfaces";

import { StudentsList, CardWrapper, StyledModal, ConnectModalWrapper, ClassForm, Buttons, SelectWrapper } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";
import QrCodeToDownloadApp from "../../../components/QrCodeToDownloadApp";
import FormattedHtmlMessage from "../../../../common/helpers/FormattedHtmlMessage";

const ConnectModal = ({ connectKey, plan, students, close, setClassId, classId }: IProps) => {
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const { c } = useTheme();
    const [isClassSetup, setIsClassSetup] = useState(!classId);
    const [selectedClassId, setSelectedClassId] = useState<string | null>(null);
    const [classes, setClasses] = useState<IClass[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleChangeClassId = (newClassId: string) => {
        setSelectedClassId(newClassId);
    }

    const handleSkip = () => {
        setIsClassSetup(false);
    };

    const handleNext = () => {
        setClassId(selectedClassId);
    }

    useEffect(() => {
        if (!!classId) {
            setIsClassSetup(false);
        }
    }, [classId]);

    useEffect(() => {
        if (isClassSetup) {
            dispatch(get("teacher-classes", (res: AxiosResponse<IClass[]>) => {
                setClasses(res.data);
                setIsLoading(false);
            }, () => {
                setIsClassSetup(false);
            }));
        }
    }, [isClassSetup]);

    return (
        <ConnectModalWrapper>
            <Title>
                <FormattedMessage {...messages.joinTitle} />
            </Title>
            {connectKey ? (
                <StyledModal>
                    <ol>
                        <li>
                            <h3>
                                <FormattedHtmlMessage {...messages.joinAppTitle1} />
                            </h3>
                            <QrCodeToDownloadApp />
                        </li>
                        <li>
                            <h3>
                                <FormattedHtmlMessage {...messages.joinAppTitle2} />
                            </h3>
                        </li>

                        <li className="StepInvisible" />
                    </ol>
                    <Method className="Width-66p">
                        <span>
                            <FormattedMessage {...messages.or} />
                        </span>
                    </Method>
                    <ol>
                        <li className="WithoutNumber">
                            <h3>
                                {formatMessage(messages.joinTitle1).replace(":", "")}
                            </h3>
                            {/* <FormattedHtmlMessage {...messages.joinContent1} /> */}
                        </li>
                        <li className="WithoutNumber">
                            <h3>
                                <FormattedMessage {...messages.joinTitle2} />
                            </h3>
                            <h2 className="h2-url">{"musicators.com/" + routing.join}</h2>
                        </li>
                        <Method className="Lastly">
                            <span>
                                <FormattedMessage {...messages.lastly} />
                            </span>
                        </Method>
                        <li className="LastStep">
                            <h3>
                                <FormattedMessage {...messages.joinTitle3} />
                            </h3>
                            <h2>{connectKey}</h2>
                        </li>
                    </ol>

                    {(students.length > 0 || !isClassSetup) && (
                        <StudentsList>
                            {students.map((student, index) => (
                                <span key={index}>
                                    {student.name}
                                    {students.length - 1 !== index && ","}{" "}
                                </span>
                            ))}
                        </StudentsList>
                    )}
                    {!isClassSetup && (
                        <CardWrapper>
                            <PlanCard plan={plan} play={close} />
                        </CardWrapper>
                    )}
                    {isClassSetup && (
                        <ClassForm>
                            <SelectWrapper>
                                <Select
                                    label={<FormattedMessage {...messages.classLabel} />}
                                    value={selectedClassId}
                                    required
                                    name="class"
                                    options={[
                                        ...parseClasses(classes, [], ""),
                                    ]}
                                    onChange={e => handleChangeClassId(e.target.value)}
                                    noDelete
                                    disabled={isLoading}
                                />
                            </SelectWrapper>
                            <Buttons>
                                <button className="button button--light" onClick={handleSkip}>
                                    <FormattedMessage {...messages.skip} />
                                </button>
                                <button className="button no-button-margin" disabled={!selectedClassId} onClick={handleNext}>
                                    <FormattedMessage {...messages.next} />
                                </button>
                            </Buttons>
                        </ClassForm>
                    )}
                </StyledModal>
            ) : (
                <LoaderWrapper>
                    <Loader />
                </LoaderWrapper>
            )}
        </ConnectModalWrapper>
    );
}
export default ConnectModal;
